import './styles/tokens.css';
import './styles/app.css';
import './styles/pages.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { prefetchHall } from './api';
import { readDevice } from './engine/quality';
import { routeOf } from './router';
import { useLayout } from './state/layout';
import { useSaving } from './state/saving';
import { useSession } from './state/session';
import { venue } from './state/store';
import { HALL_ID } from './ui/HallScreen';
import { Root } from './ui/Root';
import { loadEngine } from './ui/Stage';

// The app's state for the scripted browser checks.
Object.assign(window, { __venueState: venue, __venueLayout: useLayout, __venueSaving: useSaving, __venueSession: useSession });

/** Whether the device can draw the hall at all, and what it is (its tier picks which copy of the scan to fetch). */
function checkDevice(): boolean {
  if (new URLSearchParams(location.search).has('nowebgl')) return false;
  try {
    const gl = document.createElement('canvas').getContext('webgl2');
    if (!gl) return false;
    venue().set({ device: readDevice(gl) });
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return true;
  } catch {
    return false;
  }
}

const webgl = checkDevice();
const first = routeOf(location.pathname).page;
if (webgl && (first === 'layout' || first === 'view')) {
  // Opening the hall straight away: its manifest and the 3D engine start downloading before the interface has mounted.
  if (first === 'layout') prefetchHall(HALL_ID);
  setTimeout(() => void loadEngine(), 0);
}
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root webgl={webgl} />
  </StrictMode>,
);
